module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', [(_vm.item) ? _c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      Checklists for " + _vm._s(_vm.item.name) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "height": "400px",
      "margin-top": "20px"
    }
  }, [_c('v-list', _vm._l((_vm.checklist), function(check, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "px-0"
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [(check.loading) ? _c('v-progress-circular', {
      attrs: {
        "indeterminate": "",
        "color": "warning",
        "size": "24"
      }
    }) : _c('v-icon', {
      attrs: {
        "color": check.passed ? 'success' : 'error'
      }
    }, [_vm._v("\n              " + _vm._s(check.passed ? 'mdi-check-circle' : 'mdi-close-circle') + "\n            ")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('div', {
      staticClass: "title-section"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(check.text))])], 1), _vm._v(" "), _c('div', {
      staticClass: "value-section"
    }, [((check.igFollower || check.tiktokFollower) && !_vm.isLoading) ? _c('div', {
      staticClass: "text-left"
    }, [(check.igFollower) ? _c('div', {
      staticClass: "value-item"
    }, [_vm._v("IG Followers: " + _vm._s(_vm._f("thousandSeprator")(check.igFollower)))]) : _vm._e(), _vm._v(" "), (check.tiktokFollower) ? _c('div', {
      staticClass: "value-item"
    }, [_vm._v("TikTok Followers: " + _vm._s(_vm._f("thousandSeprator")(check.tiktokFollower)))]) : _vm._e()]) : (check.email !== undefined) ? _c('div', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "value-item"
    }, [_vm._v("Email: " + _vm._s(check.email || 'N/A'))]), _vm._v(" "), _c('div', {
      staticClass: "value-item"
    }, [_vm._v("Contact No: " + _vm._s(check.contactNo || 'N/A'))])]) : (check.value !== undefined) ? _c('div', {
      staticClass: "text-left"
    }, [(Array.isArray(check.value)) ? _c('div', {
      staticClass: "value-item"
    }, [_vm._v("\n                  " + _vm._s(check.value.join(', ')) + "\n                ")]) : _c('div', {
      staticClass: "value-item"
    }, [_vm._v("\n                  " + _vm._s(check.value) + "\n                ")])]) : _vm._e()])])], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end pa-4"
  }, [_c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        Done\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "loading": _vm.verifying,
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.loadChecklist(true)
      }
    }
  }, [_vm._v("\n        Check Validation\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09849f90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/JoinCommunity/VerifyDialog.vue
// module id = 1993
// module chunks = 0